import { useTranslation } from 'react-i18next';
import { NavigationLink } from '../../types';

export function useMenuLinks(): NavigationLink[] {
  const { t } = useTranslation();

  return [
    {
      href: 'https://www.informa.com/investors/',
      label: t('informa.ping-identity.ribbon.menu-links.investors.label'),
      description: t(
        'informa.ping-identity.ribbon.menu-links.investors.description',
      ),
      tabIndex: 1,
    },
    {
      href: 'https://www.informa.com/talent/',
      label: t('informa.ping-identity.ribbon.menu-links.talent.label'),
      description: t(
        'informa.ping-identity.ribbon.menu-links.talent.description',
      ),
      tabIndex: 2,
    },
    {
      href: 'https://www.informa.com/about-us/',
      label: t('informa.ping-identity.ribbon.menu-links.career.label'),
      description: t(
        'informa.ping-identity.ribbon.menu-links.career.description',
      ),
      tabIndex: 3,
    },
    {
      href: 'https://www.informa.com/',
      label: t('informa.ping-identity.ribbon.menu-links.informa-com.label'),
      description: t(
        'informa.ping-identity.ribbon.menu-links.informa-com.description',
      ),
      tabIndex: 4,
    },
  ];
}
